import { entries } from '@vaaas/fpts/object';
import { Text, Tuple } from '@vaaas/ts-validate';
import { Ref, inject, shallowRef, watch } from 'vue';

function parseCookie(cookie: string): Record<string, string> {
    return cookie.split('; ')
        .map(x => x.split('='))
        .filter(Tuple(Text(), Text()))
        .reduce((cookies, [k, v]) => {
            cookies[k] = decodeURIComponent(v);
            return cookies;
        }, {} as Record<string, string>);
}

function rootDomain(domain: string) {
    const parts = domain.split('.');
    if (parts.length === 2) return domain;
    else return parts.slice(-2).join('.');
}

export type IUseCookie = Ref<Record<string, string>>;

export const REQUIRE_COOKIE_KEY = Symbol('require cookie');

export const requireCookie = (): IUseCookie => {
    return inject(REQUIRE_COOKIE_KEY) || useCookie();
};

export default function useCookie(subdomains = false, D = document): IUseCookie {
    const cookie = shallowRef(parseCookie(D.cookie));

    watch(() => cookie.value, cookie => {
        for (const [k, v] of entries(cookie)) {
            let s = `${k}=${encodeURIComponent(v)}`;
            if (subdomains)
                s += `;path=/;domain=${rootDomain(D.location.hostname)}`;
            D.cookie = s;
        }
    });

    return cookie;
}
